import { RootContainer } from '../../../../../core/root_container';
import { KeywordJsEnv } from '../../../models/keyword_js_env';
import { catalogBody } from './catalog_body';
import { CatalogAction } from '../../../actions/catalog/catalog_action'

export class CatalogContainer extends RootContainer<KeywordJsEnv> {
  constructor(model: KeywordJsEnv) {
    super();
    this.mount(catalogBody, 'keyword_publishedPageInput');
    this.update(model);

    CatalogAction.UPDATE_EVENT.on(() => {
      this.update(model);
    });
  }
}
